// #247 (Chris, 2026-10-21): a JTNC trade is taken over when the client exited our
// filled entry on their own, or our entry was rejected because the account did not
// have the buying power. Both stay in JTNC P&L; the admin marks them with the red star.
const BUYING_POWER = /buying power/i;

/**
 * @param {object | null | undefined} raw tbl_user_order_backlogs row
 * @returns {'client_close' | 'buying_power' | null}
 */
export const takeoverKind = (raw) => {
  // The doc-level client_close copy also counts, as in qfaa-cc ordersFromRecords.
  if (raw?.exit?.reason === 'client_close' || raw?.client_close) return 'client_close';
  if (BUYING_POWER.test(String(raw?.reject_reason || ''))) return 'buying_power';
  return null;
};

export const TAKEOVER_TITLE = {
  client_close: 'Client Managed QFAA Trade: the client closed it',
  buying_power: 'Client Managed QFAA Trade: rejected, not enough buying power',
};
